import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import Confetti from 'react-confetti';
import { Button, H1, P, BRAND_COLOR, formatCurrency } from 'shared';
function ImprintCashFlowApproved({ increasedAmount, handleViewOffer, }) {
    return (_jsxs("div", { children: [_jsx(Confetti, { numberOfPieces: 25, initialVelocityY: 2, recycle: true, style: { zIndex: 100000000 }, colors: [
                    BRAND_COLOR.RED,
                    BRAND_COLOR.ORANGE,
                    BRAND_COLOR.PURPLE,
                    BRAND_COLOR.NAVY,
                    BRAND_COLOR.GREEN,
                ] }), _jsx(H1, { children: "You're Pre-qualified for a Higher Loan Amount!" }), _jsxs(P, { variant: "title-large", className: "mar-t-32", children: ["Congratulations! You\u2019re now pre-qualified for a loan of", ' ', formatCurrency(increasedAmount), "\u2014an increase from your original offer."] }), _jsx(Button, { type: "button", className: "button-warn-advantage mar-t-32", onClick: handleViewOffer, children: "VIEW OFFER" })] }));
}
export default ImprintCashFlowApproved;
